import React, { useState } from 'react';
import { C } from '../theme';
import { Card, CardTitle, RCard, QuoteBox, FinInput, BtnPrimary, Badge } from '../components/Card';
import { calcRoot, getCompatibility, ROOT_DATA } from '../utils/data';

export default function CompareScreen() {
  const [n1, setN1] = useState(''); const [d1, setD1] = useState(''); const [m1, setM1] = useState(''); const [y1, setY1] = useState('');
  const [n2, setN2] = useState(''); const [d2, setD2] = useState(''); const [m2, setM2] = useState(''); const [y2, setY2] = useState('');
  const [result, setResult] = useState(null);

  function run() {
    const pd1=parseInt(d1),pm1=parseInt(m1),py1=parseInt(y1);
    const pd2=parseInt(d2),pm2=parseInt(m2),py2=parseInt(y2);
    if(!pd1||!pm1||!py1||!pd2||!pm2||!py2){alert('يرجى إدخال تاريخ الميلاد للشخصين');return;}
    const r1=calcRoot(pd1,pm1,py1), r2=calcRoot(pd2,pm2,py2);
    const combined=(() => { let s=r1+r2; while(s>9) s=String(s).split('').reduce((a,b)=>a+parseInt(b),0); return s; })();
    setResult({r1,r2,combined,rd1:ROOT_DATA[r1]||ROOT_DATA[1],rd2:ROOT_DATA[r2]||ROOT_DATA[1],rComb:ROOT_DATA[combined]||ROOT_DATA[1],compat:getCompatibility(r1,r2),n1:n1||'الشخص الأول',n2:n2||'الشخص الثاني'});
  }

  return (
    <div>
      <QuoteBox text="حين يلتقي رقمان، تُولد بينهما طاقة ثالثة لم تكن موجودة من قبل" src="جذر الفلك، الجزء الثاني" />
      <Card>
        <CardTitle>⚖ مقارنة رقمين لشخصين</CardTitle>
        {[['الشخص الأول',n1,setN1,d1,setD1,m1,setM1,y1,setY1],['الشخص الثاني',n2,setN2,d2,setD2,m2,setM2,y2,setY2]].map(([label,name,setName,day,setDay,mon,setMon,yr,setYr]) => (
          <div key={label} style={{marginBottom:16}}>
            <div style={{fontSize:12,color:C.gold,fontFamily:'Amiri,serif',marginBottom:8,display:'flex',alignItems:'center',gap:8}}>{label}<div style={{flex:1,height:1,background:`linear-gradient(to left, transparent, ${C.goldDim})`}}/></div>
            <FinInput value={name} onChange={e=>setName(e.target.value)} placeholder="الاسم" style={{marginBottom:8}}/>
            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1.4fr',gap:8}}>
              <FinInput value={day} onChange={e=>setDay(e.target.value)} placeholder="يوم" type="number" min="1" max="31"/>
              <FinInput value={mon} onChange={e=>setMon(e.target.value)} placeholder="شهر" type="number" min="1" max="12"/>
              <FinInput value={yr} onChange={e=>setYr(e.target.value)} placeholder="سنة" type="number" min="1900" max="2020"/>
            </div>
          </div>
        ))}
        <BtnPrimary onClick={run}>✦ قارن الرقمين</BtnPrimary>
      </Card>

      {result && (
        <div style={{animation:'fadeUp .35s ease'}}>
          <div style={{background:`linear-gradient(135deg,${C.bg3},${C.bg4})`,border:`1px solid ${C.border}`,borderRadius:14,padding:16,marginBottom:12,display:'flex',alignItems:'center',justifyContent:'space-around',gap:12,flexWrap:'wrap'}}>
            {[{r:result.r1,name:result.n1,rd:result.rd1},{r:result.r2,name:result.n2,rd:result.rd2}].map((p,i) => (
              <React.Fragment key={i}>
                <div style={{textAlign:'center'}}>
                  <div style={{width:56,height:56,border:`2px solid ${C.goldDim}`,borderRadius:'50%',display:'flex',alignItems:'center',justifyContent:'center',fontFamily:'Amiri,serif',fontSize:26,color:C.gold,margin:'0 auto 6px'}}>{p.r}</div>
                  <div style={{fontSize:13,color:C.text,fontWeight:600}}>{p.name}</div>
                  <div style={{fontSize:10,color:C.text2}}>{p.rd.title}</div>
                  <div style={{fontSize:10,color:C.goldDim}}>{p.rd.planet}</div>
                </div>
                {i===0 && <div style={{fontSize:24,color:C.goldDim,fontFamily:'Amiri,serif'}}>+</div>}
              </React.Fragment>
            ))}
          </div>

          <div style={{background:`linear-gradient(135deg,${C.bg3},${C.bg4})`,border:`1px solid ${C.goldDim}`,borderRadius:14,padding:16,textAlign:'center',marginBottom:8}}>
            <div style={{fontFamily:'Amiri,serif',fontSize:52,color:C.gold,textShadow:'0 0 24px rgba(212,168,71,.4)',lineHeight:1,marginBottom:4}}>{result.combined}</div>
            <div style={{fontSize:13,color:C.text2,marginBottom:3}}>رقم العلاقة المشتركة</div>
            <div style={{fontSize:12,color:C.text2}}>{result.rComb.desc}</div>
          </div>

          <RCard type={result.compat.type}>
            <div style={{fontSize:12,color:C.gold,fontWeight:600,marginBottom:8}}>⚖ توافق الرقمين {result.r1} و {result.r2}</div>
            <div style={{fontSize:14,lineHeight:1.75,marginBottom:8}}>{result.compat.msg}</div>
            <ul style={{listStyle:'none',padding:0,margin:0}}>
              {result.compat.points.map(p=><li key={p} style={{fontSize:12,color:C.text2,paddingRight:14,position:'relative',marginBottom:5,lineHeight:1.6}}><span style={{position:'absolute',right:0,color:C.goldDim,fontSize:8,top:4}}>◆</span>{p}</li>)}
            </ul>
          </RCard>

          <RCard>
            <div style={{fontSize:12,color:C.gold,fontWeight:600,marginBottom:8}}>🔮 نقطة التوازن بينكما</div>
            <div style={{fontSize:14,lineHeight:1.75}}>رقم العلاقة {result.combined} — {result.rComb.title} — يعني أن هذه العلاقة تحمل طاقة {result.rComb.desc}. الرقم المضاد لها: {result.rComb.contra}</div>
          </RCard>
        </div>
      )}
    </div>
  );
}
